@if(evenement){
<div class="event-element" [routerLink]="['/evenement', evenement.documentId]">
    @if(evenement.complet) {
    <div class="evenement-complet"></div>
    }

    <div class="header" [ngStyle]="{'background':'#' + evenement.couleur}">{{evenement.startDate | date}}</div>
    <h3 class="titre">{{evenement.titre}}</h3>
    <div class="content">
        <p>{{evenement.descriptionCourte}}</p>
        <div class="crop-thumbnail" [ngStyle]="{'transform': 'rotate(' + randomRotation + 'deg)'}">
            <span class="corner corner-top"></span>
            <img [src]="getImageUrl(evenement.gallery[0].url)" alt="">
            <span class="corner corner-bottom"></span>
        </div>
    </div>
    <div class="footer">
        <img src="/icons/marker-fill.svg" alt="">
        <p>{{evenement.lieu?.ville}}</p>
        <div class="page-corner"></div>
    </div>
</div>
}